import React, { useEffect, useRef, useState } from "react";
import { FiX } from "react-icons/fi";
import { Navigation, Autoplay, FreeMode, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import SwiperCore from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { truncateText } from "../../utilis/utils";
import { useGetAllPopUpPublicQuery } from "../../Redux/getApi";
import { NavLink } from "react-router-dom";
import rdaLogo from "../../asset/rda-web-logo 1.png";
import { ReactSVG } from "react-svg";
import { HiOutlineInformationCircle } from "react-icons/hi";

SwiperCore.use([Navigation]);

const links = [
  {
    name: "Public Notices",
    link: "/public-notices",
    icon: "/icon/Public Notices.svg",
  },
  {
    name: "Development Projects",
    link: "/project-2",
    icon: "/icon/Development Projects.svg",
  },
  {
    name: "Lodge Complaints",
    link: "https://cms.rda.gop.pk",
    icon: "/icon/Lodge Complaints.svg",
  },
];

const PopUp = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const [open, setOpen] = useState(false);
  const [openWelcome, setOpenWelcome] = useState(false);
  const [openTest, setOpenTest] = useState(false);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const thumbRefs = useRef([]);
  const { data, isFetching, isLoading } = useGetAllPopUpPublicQuery();
  const popUps = data?.popUp;

  useEffect(() => {
    if (!openTest) {
      if (popUps && popUps?.length > 0) {
        setOpen(true);
        setOpenWelcome(false);
      } else if (!isFetching && !isLoading) {
        setOpenWelcome(true);
        setOpen(false);
      }
    }
  }, [popUps, isLoading, isFetching, openTest]);

  useEffect(() => {
    if (openTest) {
      const timer = setTimeout(() => setOpenTest(false), 15000);
      return () => clearTimeout(timer);
    }
    if (open) {
      const timer = setTimeout(() => setOpen(false), 30000);
      return () => clearTimeout(timer);
    }
    if (openWelcome) {
      const timer = setTimeout(() => setOpenWelcome(false), 20000);
      return () => clearTimeout(timer);
    }
  }, [open, openWelcome, openTest]);

  useEffect(() => {
    if (thumbRefs.current[currentSlide - 1]) {
      thumbRefs.current[currentSlide - 1].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [currentSlide]);

  if (!open && !openWelcome && !openTest) return null;

  return (
    <div className=" fixed inset-0 flex items-center justify-center bg-[#243F5C4D] backdrop-blur-md z-[100]">
      {!openTest ? (
        popUps?.length > 0 ? (
          open && (
            <div className="w-[95%] max-w-3xl h-max max-h-[95vh] mx-auto rounded-xl flex flex-col overflow-x-hidden overflow-y-auto scrollbar-hide">
              <div className="flex items-center justify-between gap-3 bg-gradient-to-b from-[#00643B] to-[#008049] p-2">
                <div className="text-white flex items-center gap-3">
                  <div className="bg-[#FFFFFF33] rounded-[10px] py-2 px-4 text-lg font-semibold">
                    Announcements
                  </div>
                  <span className="text-[#FFFFFFCC] text-sm">
                    {currentSlide}/{popUps?.length}
                  </span>
                </div>
                <button
                  onClick={() => setOpen(false)}
                  className="bg-[#FFFFFF33] text-white p-2 rounded-full aspect-square"
                >
                  <FiX className="size-6" />
                </button>
              </div>

              <div className="w-full bg-white relative">
                <Swiper
                  modules={[Navigation, Autoplay, FreeMode, Pagination]}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  onInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                  }}
                  onSlideChange={(swiper) =>
                    setCurrentSlide(swiper.realIndex + 1)
                  }
                  speed={1000}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    stopOnLastSlide: false,
                  }}
                  loop={true}
                  className="custom-swiper"
                >
                  {popUps?.map((popUp, i) => (
                    <SwiperSlide key={i} className="flex flex-col w-full">
                      {/* ✅ CHANGE: fixed responsive height + contain for images */}
                      <div className="w-full bg-[#F3F4F6] flex items-center justify-center md:h-[360px] h-[220px]">
                        {popUp?.media?.fileType.startsWith("image/") ? (
                          <img
                            src={popUp?.media?.mediaUrl}
                            alt={`Slide ${i + 1}`}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <video
                            src={popUp?.media?.mediaUrl}
                            controls
                            autoPlay
                            muted
                            className="w-full h-full object-cover"
                          />
                        )}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                <div className="flex gap-4 items-center justify-between absolute inset-0 md:px-4 px-3 top-1/2 -translate-y-1/2 text-[#00643b] z-10">
                  <button
                    ref={prevRef}
                    className="p-2 bg-[#FFFFFFE5] rounded-full aspect-square flex items-center justify-center"
                  >
                    <IoIosArrowBack className="md:size-5 size-4" />
                  </button>

                  <button
                    ref={nextRef}
                    className="p-2 bg-[#FFFFFFE5] rounded-full aspect-square flex items-center justify-center"
                  >
                    <IoIosArrowForward className="md:size-5 size-4" />
                  </button>
                </div>

                <div className="absolute bottom-2 right-2 z-10 bg-[#00000080] backdrop-blur-sm py-[2px] px-2 text-white rounded-md text-sm">
                  {currentSlide}/{popUps?.length}
                </div>

                {/* {popUps?.map((pop, index) => {
                  if (currentSlide === index + 1) {
                    return (
                      <div
                        key={pop._id || index}
                        className="absolute top-2 right-2 z-10 bg-[#ffffff] backdrop-blur-sm text-[#00643b] py-1 px-3 rounded-md text-sm font-semibold"
                      >
                        {new Date(pop.startDate).toLocaleDateString("en-US", {
                          month: "long",
                          day: "numeric",
                          year: "numeric",
                        })}
                      </div>
                    );
                  }
                  return null;
                })} */}

                {popUps?.map((pop, index) => {
                  if (currentSlide === index + 1) {
                    return (
                      <div
                        key={index}
                        className="absolute top-2 left-2 z-10 bg-[#00000080] backdrop-blur-sm py-[2px] px-2 text-white rounded-md text-sm"
                      >
                        {pop?.media?.fileType.startsWith("image/")
                          ? "Image"
                          : "Video"}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>

              <div className="w-full bg-[#F9FAFB]">
                <div className="overflow-x-auto scroll-smooth scrollbar-hide">
                  <div className="flex w-max md:gap-3 gap-2 md:p-4 p-3 snap-x snap-mandatory">
                    {popUps?.map((popUp, index) => (
                      <div
                        key={index}
                        ref={(el) => (thumbRefs.current[index] = el)}
                        className={`relative snap-start overflow-hidden rounded-lg border md:w-[150px] w-[100px] aspect-video transition cursor-pointer
                        ${
                          currentSlide === index + 1
                            ? "border-[#00643b]"
                            : "border-transparent hover:border-[#00643b]"
                        }`}
                      >
                        {popUp?.media?.fileType.startsWith("image/") ? (
                          <img
                            src={popUp?.media?.mediaUrl}
                            alt={`Slide ${index + 1}`}
                            className={`w-full h-full object-cover ${
                              currentSlide === index + 1
                                ? "opacity-100"
                                : "opacity-80"
                            }`}
                          />
                        ) : (
                          <video
                            src={popUp?.media?.mediaUrl}
                            className={`w-full h-full object-cover ${
                              currentSlide === index + 1
                                ? "opacity-100"
                                : "opacity-80"
                            }`}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {popUps?.map((pop, index) => {
                if (currentSlide === index + 1) {
                  return (
                    <div
                      key={index}
                      className="w-full flex flex-col md:gap-3 gap-2 bg-white md:p-5 p-4"
                    >
                      <h1 className="md:text-[1.875rem] text-[1.4rem] leading-[1.1] font-bold text-[#00643b]">
                        {pop?.title}
                      </h1>
                      <p className="text-[#364153] md:text-lg text-base">
                        {truncateText(pop?.description, 200)}
                      </p>
                      <div className="flex items-center md:gap-3 gap-2 md:text-base text-sm">
                        {pop?.buttonText && (
                          <NavLink
                            to={pop?.buttonLink}
                            onClick={() => setOpen(false)}
                            className="text-white bg-[#00643B] border border-[#00643B] rounded-[10px] font-semibold py-[6px] px-3"
                          >
                            {pop?.buttonText}
                          </NavLink>
                        )}
                        <button
                          onClick={() => setOpen(false)}
                          className="text-[#00643B] bg-transparent border border-[#00643B] rounded-[10px] font-semibold py-[6px] px-3"
                        >
                          Dismiss
                        </button>
                      </div>
                    </div>
                  );
                }
                return null;
              })}

              <div className="bg-[#F9FAFB] flex items-center gap-2 justify-center w-full p-3">
                {popUps?.map((_, index) => (
                  <div
                    key={index}
                    className={`transition-all duration-300 ${
                      currentSlide === index + 1
                        ? "bg-[#00643B] w-8 h-2 rounded-xl"
                        : "bg-[#D1D5DC] w-2 h-2 rounded-full"
                    }`}
                  ></div>
                ))}
              </div>
            </div>
          )
        ) : (
          openWelcome && (
            <div className="w-[95%] max-w-xl h-max max-h-[95vh] mx-auto rounded-xl flex flex-col overflow-x-hidden overflow-y-auto scrollbar-hide">
              <div className="relative flex items-center justify-center flex-col gap-3 bg-gradient-to-b from-[#00643B] to-[#008C52] p-4">
                <button
                  onClick={() => setOpenWelcome(!openWelcome)}
                  className="absolute top-2 right-2 bg-[#FFFFFFE5] text-[#00643B] p-2 rounded-full aspect-square"
                >
                  <FiX className="sm:size-6 size-5" />
                </button>
                <span className="bg-white p-2 rounded-md aspect-square sm:w-20 w-16">
                  <img src={rdaLogo} alt="logo" />
                </span>
                <h1 className="sm:text-[2.5rem] text-[1.5rem] leading-[1.1] text-center font-semibold text-white">
                  Welcome to Rawalpindi Development Authority
                </h1>
              </div>
              <div className="flex flex-col items-center justify-center p-4 bg-white gap-4">
                <p className="text-[#4E4E4E] sm:text-lg text-[13px] text-center">
                  Your gateway to modern urban development and civic services.
                  We're dedicated to transforming Rawalpindi into a world-class
                  city through sustainable planning, efficient services, and
                  transparent governance.
                </p>
                <div className="grid grid-cols-3 sm:gap-3 gap-2">
                  {links?.map((link, i) => (
                    <div
                      key={i}
                      className="w-full flex flex-col gao-2 items-center justify-start"
                    >
                      <NavLink
                        to={link?.link}
                        target={link?.name === "Lodge Complaints" && "_blank"}
                        onClick={() => setOpenWelcome(!openWelcome)}
                        className="w-full rounded-lg flex items-center sm:h-14 h-12 justify-center bg-[#E6F2ED]"
                      >
                        <span className="sm:w-6 w-5">
                          <ReactSVG src={link?.icon} alt={link?.name} />
                        </span>
                      </NavLink>
                      <p className="sm:text-sm text-xs text-[#2B2B2B] text-center">
                        {link?.name}
                      </p>
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => setOpenWelcome(!openWelcome)}
                  className="cursor-pointer bg-[#00643B] text-white sm:text-base text-sm font-semibold py-2 px-4 rounded-lg"
                >
                  Explore the Website
                </button>
                <p className="text-center text-sm text-[#9A9A9A]">
                  Building a Better Tomorrow, Today
                </p>
              </div>
            </div>
          )
        )
      ) : (
        <div className=" bg-white max-w-sm flex items-center justify-center flex-col gap-3 w-[95%] rounded-xl p-5">
          <span className=" bg-[#00643B1C] rounded-full p-3 aspect-square">
            <HiOutlineInformationCircle className=" size-7 text-[#00643B]" />
          </span>
          <h1 className=" text-[#101828] font-semibold text-center">
            Test Phase Notice
          </h1>
          <p className="text-[#4A5565] text-center">
            This revamped website is currently in test-run phase; any errors or
            omissions are regretted.
          </p>

          <button
            type="button"
            onClick={() => setOpenTest(false)}
            className=" bg-[#00643B] text-white font-medium px-4 py-2 rounded-lg"
          >
            I Understand
          </button>
        </div>
      )}
    </div>
  );
};

export default PopUp;
